import { render, staticRenderFns } from "./privacyAgreementList.vue?vue&type=template&id=447531ee"
import script from "./privacyAgreementList.vue?vue&type=script&lang=js"
export * from "./privacyAgreementList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports